import React from "react";
import { ReactComponent as Error } from "../../assets/img/error.svg"

export default function Error404() {
    return (
        <Error />
    )
}
